import {Space, Tag} from "antd";


export default function ({filters, onClose}) {
    return filters.length > 0 && <Space size={10}>
        Filtri:
        {filters.map((x, i) => <Tag style={{margin: 0}} key={x.id} closable onClose={() => onClose(x.id)}>{x.label}</Tag>)}
    </Space>
}